import { useLayoutEffect, useState } from 'react';
import { readContentSize } from './meeting-layout.js';

const EMPTY_SIZE = { width: 0, height: 0 };

export function useContentSize(elementRef, enabled, target) {
    const [size, setSize] = useState(EMPTY_SIZE);
    useLayoutEffect(() => {
        const element = elementRef.current;
        if (!enabled || !element) {
            setSize((current) => current.width || current.height ? EMPTY_SIZE : current);
            return undefined;
        }
        let mounted = true;
        const measure = () => {
            if (!mounted) return;
            const next = readContentSize(element);
            setSize((current) => current.width === next.width && current.height === next.height ? current : next);
        };
        measure();
        const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
        observer?.observe(element);
        window.addEventListener('resize', measure);
        window.addEventListener('orientationchange', measure);
        return () => {
            mounted = false;
            observer?.disconnect();
            window.removeEventListener('resize', measure);
            window.removeEventListener('orientationchange', measure);
        };
    }, [elementRef, enabled, target]);
    return size;
}
